//@ts-nocheck
// eslint-disable-next-line unused-imports/no-unused-imports
import React from 'react';

import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button';
import { FormFooter } from '@atlaskit/form';
import ShortcutIcon from '@atlaskit/icon/core/link-external';
import { media } from '@atlaskit/primitives/responsive';

export type SiteSelectorFormFooterProps = {
	readonly canSubmit: boolean;
	readonly onSwitchAccountClick: () => void;
	readonly onCancelClick: () => void;
	readonly fullScreenView?: boolean;
};

const SiteSelectorFormFooter = ({
	canSubmit,
	onSwitchAccountClick,
	onCancelClick,
	fullScreenView,
}: SiteSelectorFormFooterProps) => {
	return (
		<FormFooter>
			<div css={actionContainerStyle}>
				<div css={leftActionsContainerStyle}>
					<Button
						appearance="link"
						type="button"
						spacing="none"
						onClick={() => onSwitchAccountClick()}
					>
						<FormattedMessage
							id="SiteSelectorModal.switchAccount"
							defaultMessage="Sign in with a different account"
						/>
					</Button>
				</div>
				<div css={rightActionsContainerStyle}>
					{fullScreenView !== true ? (
						<div css={inlineEndStyle}>
							<Button appearance="subtle" type="button" onClick={() => onCancelClick()}>
								<FormattedMessage id="SiteSelectorModal.cancel" defaultMessage="Cancel" />
							</Button>
							<div css={primaryContainerStyle}>
								<Button
									appearance="primary"
									type="submit"
									isDisabled={!canSubmit}
									iconAfter={<ShortcutIcon label="" />}
								>
									<FormattedMessage
										id="SiteSelectorModal.createPage"
										defaultMessage="Create page"
									/>
								</Button>
							</div>
						</div>
					) : (
						<Button appearance="primary" type="submit" isDisabled={!canSubmit} css={inlineEndStyle}>
							<FormattedMessage id="SiteSelectorModal.createPage" defaultMessage="Create page" />
						</Button>
					)}
				</div>
			</div>
		</FormFooter>
	);
};

const actionContainerStyle = css({
	marginBlockStart: '8px',
	position: 'relative',
	width: '100%',
	display: 'flex',
	flexWrap: 'wrap',
	[media.above.sm]: {
		justifyContent: 'space-between',
		alignItems: 'center',
	},
});

const leftActionsContainerStyle = css({
	flexShrink: 0,
});

const rightActionsContainerStyle = css({
	marginBlockStart: '16px',
	[media.above.sm]: {
		marginBlockStart: '0px',
		flexShrink: 0,
		flexGrow: 1,
		textAlign: 'right',
	},
});

const inlineEndStyle = css({
	marginInlineEnd: '4px',
	display: 'flex',
	justifyContent: 'flex-end',
});

const primaryContainerStyle = css({
	marginInlineStart: '4px',
});

export default SiteSelectorFormFooter;
